import { render } from "./MasterBook.vue?vue&type=template&id=aae6e616"
import script from "./MasterBook.vue?vue&type=script&lang=js"
export * from "./MasterBook.vue?vue&type=script&lang=js"
script.render = render

export default script